import { render, staticRenderFns } from "./ProjectGrade.vue?vue&type=template&id=56767d7b&scoped=true"
import script from "./ProjectGrade.vue?vue&type=script&lang=js"
export * from "./ProjectGrade.vue?vue&type=script&lang=js"
import style0 from "./ProjectGrade.vue?vue&type=style&index=0&id=56767d7b&prod&lang=css"
import style1 from "./ProjectGrade.vue?vue&type=style&index=1&id=56767d7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56767d7b",
  null
  
)

export default component.exports